import { inject, observer } from "mobx-react";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Box from "react-raster";
import { theme } from "src/config";
import { RoutingStore } from "src/stores";
import styled from "styled-components";
import { Spacer } from ".";
import { Icon } from "../components/icon";
import { Text } from "../components/text";

export interface ISideMenuProps {
  routingStore?: RoutingStore;
  onClick?: () => void;
}

type MenuItemProps = {
  $active?: boolean;
};

const MenuBox = styled.div`
  width: 16rem;
  font-weight: ${theme.font.weight.normal};
  font-size: ${theme.font.size.small};
  cursor: pointer;
  margin-right: 1rem;
  display: flex;
  flex-direction: column;
`;

const HeaderBox = styled(Box)`
  margin-left: 0.5rem;
  margin-bottom: 0.5rem;
`;

const MenuItem = styled(Box)<MenuItemProps>`
  display: flex;
  padding: 0.75rem 0.75rem;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  background: ${(props) => props.$active ? `${theme.color.blackA3}` : "transparent"};

  :hover {
    background: ${theme.color.blackA2};
    cursor: pointer;
  }
`;

export const SideMenu: FC<ISideMenuProps> = inject("routingStore")(observer((props: ISideMenuProps): JSX.Element => {
    const { t, i18n } = useTranslation();
    const { routingStore } = props;
    return (
      <MenuBox>
        <HeaderBox>
          <Text size="large" weight="bold">{t("settings")}</Text>
        </HeaderBox>
        <MenuItem
          onClick={() => props.routingStore.push("/user/settings")}
          $active={routingStore.location.pathname === "/user/settings"}
        >
          <Icon size="medium" iconId="profile" />
          <Spacer size="xsmall"/>
          <Text size="small">{t("profile")}</Text> 
        </MenuItem>

        <MenuItem
          onClick={() => props.routingStore.push("/user/notification-settings")}
          $active={routingStore.location.pathname === "/user/notification-settings"}
        >
          <Icon size="medium" iconId="notification" />
          <Spacer size="xsmall" />
          <Text size="small">{t("email")}</Text>
        </MenuItem>

        <MenuItem
          onClick={() => props.routingStore.push("/user/newsfeed-settings")}
          $active={routingStore.location.pathname === "/user/newsfeed-settings"}
        >
          <Icon size="medium" iconId="new" />
          <Spacer size="xsmall" />
          <Text size="small">{t("news_feed")}</Text>
        </MenuItem>
      </MenuBox>
    );
  })
);
